// extracted by mini-css-extract-plugin
export var option = "_5d-1";
export var optionActive = "_5d-2";
export var pill = "_5d-0";